app.CONSTANTS = {
	MAX_INT_AMOUNT_LEN: 8,
	DEVICE_TYPE        : {
		MOBILE  : 'mobile',
		DESKTOP : 'desktop'
	},
	HASH               : {
		PM      : '#/pm/',
		DETAILS : '#/details/'
	},
	MESSAGES_MODE      : {
		NONE       : 'NONE',
		PLAYTECH   : 'PLAYTECH',
		SAFECHARGE : 'SAFECHARGE'
	},
	PM_NAME            : {
		ABON            : 'apmgw_Abon',
		BLIK            : 'apmgw_BLIK',
		FBT           	: 'apmgw_Fast_Bank_Transfer',
		CITADEL       	: 'apmgw_Citadel',
		INSTANT_OPEN_BANKING: 'apmgw_Instant_Open_Banking',
		KONBINI			: 'apmgw_Konbini',
		GOOGLE_PAY      : 'ppp_GooglePay',
		LEAN            : 'apmgw_Lean',
		OKTO_WALLET     : 'apmgw_OKTO_WALLET',
		OKTO_CASH       : 'apmgw_OKTO_CASH',
		OCTOPUS 	   	: 'apmgw_Octopus',
		ONLINE_BANK_TRANSFER: 'apmgw_Online_Bank_Transfer',
		OPEN_BANKING    : 'apmgw_Open_Banking',
		STP_MEX       	: 'apmgw_STPmex',
		WIRE_TRANSFER 	: 'ppp_WireTransfer',
		PAY_NEAR_ME		: 'apmgw_PayNearMe',
		PAY_WITH_MY_BANK: 'apmgw_Online_Banking',
		PAYSAFECARD     : 'apmgw_PaySafeCard',
		PAYSHOP     	: 'apmgw_Payshop',
		PAYBYCASH_OPEN_AMOUNT: 'apmgw_Paybycash_OpenAmount',
		PAYTO           : 'apmgw_PayTo',
		PIX_OPEN_FINANCE: 'apmgw_PIXViaOpenFinance',
		PLAY_PLUS       : 'apmgw_PlayPlus',
		PAY_WITH_CRYPTO : 'apmgw_PayWithCrypto',
		INSTANT_WIRE_TRANSFER: 'ppp_InstantWireTransfer',
		CREDIT_CARD        : 'cc_card',
		DEBIT_CARD         : 'dc_card',
		MVP_NUVEI_CARD: 'ppp_MVP'
	},
	RTL_LOCALES 	   : {
		'iw_IL': 1,
		'ar_AA': 1,
		'ar_QA': 1, // Quatar
		'ar_KW': 1, // Kuwait
		'ar_AE': 1, // United Arab Emirates
		'ar_SA': 1, // Saudi Arabia
		'ar_BH': 1, // Bahrain
		'ar_LB': 1, // Lebanon
		'ar_JO': 1, // Jordan
		'ar_EG': 1, // Egypt
		'ar_MA': 1, // Morocco
		'ar_OM': 1, // Oman
		'ar_TN': 1, // Tunisia
		'ar_DZ': 1, // Algeria
	},
	TRX_STATUS         : {
		APPROVED : 'APPROVED',
		PENDING  : 'PENDING',
		CANCEL   : 'CANCEL'
	},
	VERIFICATION_STATUS         : {
		NEW 			: 'NEW',
		PENDING  		: 'PENDING_VERIFICATION',
		NOT_VERIFIED  	: 'NOT_VERIFIED',
		VERIFIED  		: 'VERIFIED'
	},
	SRV_RESPONSE       : {
		STATUS_FAIL         : 'FAIL',
		STATUS_OK           : 'OK',
		MSG_SESSION_EXPIRED : 'session_expired',
		PROP_CUSTOM_FEES    : 'customFees'
	},
	FEE                : {
		TYPE_ADDING      : 'ADDING',
		// TYPE_DEDUCTION      : 'DEDUCTION',
		VALUE_TYPE_FIXED : 'FIXED'
		// ,VALUE_TYPE_PERCENT  : 'PERCENT'
	},
	MODAL_MESSAGE_TYPE : {
		SUCCESS               : 'success',
		EXTENDED_SUCCESS      : 'extended_success',
		PENDING               : 'pending',
		WARNING               : 'warning',
		ERROR                 : 'error',
		ERROR_SUGGEST         : 'error-suggest',
		VALIDATION_BOX        : 'validation_box',
		DEPOSIT_CONFIRMATIONS : 'deposit_confirmations',
		INFO                  : 'info',
		CONFIRM_UPO_REMOVAL   : 'confirm_upo_removal',
		UPO_WAS_REMOVED   	  : 'upo_was_removed',
		UPO_VERIFICATION_FAILED   : 'verification_failed'
	},
	VISIBILITY_MODE    : {
		DISABLED : 'DISABLED',
		REQUIRED : 'REQUIRED',
		HIDDEN   : 'HIDDEN'
	},
	ACCEPTED_CC_BY_PM  : {
		ENTROPAY              : {'entropay' : 1},
		APMGW_ASTROPAYPREPAID : {'astropay_card' : 1},
		NUVEI_CARD: {'nuvei_card': 1},
		BANCONTACT_CC_CARD: {'bancontact': 1}
	},
	CC_CARDS_DB        : {
		'cc_card'   : 1,
		'dc_card'   : 1,
		'paydotcom' : 1,
		'entropay'  : 1,
		'nuvei_card': 1,
		'bancontact_cc_card': 1
		// ,'astropay'  : 1
	},
	DUAL_BRANDED_CARD_SLAVE_BRANDS: [
		'bancontact',
		'carte_bancaire',
		'eftpos'
	],
	KNOWN_STATES_FOR_COUNTRY : { // PREDEFINED_STATES_FOR_COUNTRY
		"US": 1,
		"CA": 1,
		"IN": 1,
		"NZ": 1,
		"GB": 1,
		"AU": 1
	},
	PM_SUPPORTS_3DSV2 : {
		'cc_card'   : 1,
		'dc_card'   : 1,
		'ppp_GooglePay' : 1,
		'nuvei_card': 1,
		'bancontact_cc_card': 1
	},
	PM_CUSTOM_BTN : {
		'apmgw_VenmoPP'   : {forUpo: "app.util.checkIsUpoRedirect", fn: "app.util.Ppl.createBtn", args:[{pmName:'apmgw_VenmoPP'    /*, bodyClassName: "custom_btn" */}]},
		'apmgw_PayPal_SDK': {forUpo: "app.util.checkIsUpoRedirect", fn: "app.util.Ppl.createBtn", args:[{pmName:'apmgw_PayPal_SDK' /*, bodyClassName: "custom_btn" */}]},
		'apmgw_Pay_Later' : {forUpo: true,  fn: "app.util.Ppl.createBtn", args:[{pmName:'apmgw_Pay_Later'  /*, bodyClassName: "custom_btn" */}]},
	},
	DROPDOWN_VALUE_DEPENDENT_FIELDS: {
		/** pmName: {dropdownFieldName: [ ...DependentFields]}} */
		apmgw_CoDi: {codi_method: ["codi_phone_number"]},
		apmgw_PayTo: {payto_payment_type: ["payto_bsb", "payto_account_number", "payto_account_name", "payto_pay_id_type", "payto_pay_id"]},
		apmgw_Online_Bank_Transfer_Malaysia: {mobi_accountType: ["mobi_bankCodeRetail", "mobi_bankCodeCorporate"]},
	},
	FIELD_PREFIXES_PER_PM : {
		"visa_checkout"            : 'visa_checkout_',          // fld: 'visa_checkout_cc_cvv2' ONLY
		"apmgw_AstropayPrePaid_BF" : 'astro_pay_prepaidBF_',
		"apmgw_AstropayPrePaid"    : 'astro_pay_prepaid_'
	},
	PREFIXABLE_FIELDS : { // baseFields
		cc_cvv2           : 1,
		cc_card_number    : 1,
		expiration_period : 1,
		cc_exp_month      : 1,
		cc_exp_year       : 1
	},
	UPM_ONLY_FIELDS : {
		'cardArtsUrl'           : 1,
		'pwmb_providerName'     : 1,
		'visa_checkout_cc_cvv2' : 1,
		'paynearme_returnUrl' 	: 1,
		'trustly_di_info'    	: 1,
		'mazoomaFiAcc'          : 1,
		'mazoomaFiName'         : 1,
		'ach_bank_name'         : 1,
		'ach_account_number'    : 1,
		'ibtBankName'           : 1,
		'ibtAccountType'        : 1,
		'pix_key'               : 1,
		'pix_bankId'            : 1,
		'pix_bankAccountNumber' : 1,
		'pix_branchId'          : 1,
		'pbaIban'             	: 1,
		'pwbt_iban'             : 1,
		'pwbt_account_number'   : 1,
		'pwbt_sort_code'        : 1,
		'pwbt_bank_name'        : 1
	},
	SPECIAL_FIELDS     : [	/** if they are available for a PM, they should also be rendered for the corresponding UPM */
		'personal_id', 'dankort_acq', 'astro_pay_prepaid_cc_cvv2', 'astro_pay_prepaid_cc_exp_month', 'astro_pay_prepaid_cc_exp_year', 'astro_pay_prepaid_cc_card_number',
		'astro_pay_prepaidBF_cc_cvv2', 'astro_pay_prepaidBF_cc_exp_month', 'astro_pay_prepaidBF_cc_exp_year', 'astro_pay_prepaidBF_cc_card_number',
		'installment_program', 'debit_type', 'number_of_installments', 'israeli_card_holder_id', 'passportNumber', 'blik_code', 'abon_voucherNumber'
	],
	CARD_LOGO_CLASSES  : 'noneLogo master_cardLogo paydotcomLogo entropay_master_cardLogo entropay_visaLogo visaLogo diners_club_internationalLogo amexLogo jcbLogo discover_cardLogo maestroLogo switchLogo soloLogo laserLogo israeli_cardLogo mirLogo dankortLogo dankort_visaLogo astropay_cardLogo china_unionLogo nuvei_cardLogo il_card bancontactLogo carte_bancaireLogo eftposLogo',
	APPLE_PAY_FLOW_4   : "jsiframe",
	OFFLINE_METHODS    : {},
	EXP_DATE_TPL       : '<div class="row cc-exp-date oneRowDate"><select name="<%-prefix%>cc_exp_month" id="<%-prefix%>cc_exp_month" style="position: absolute; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0" tabindex="-1">' +
	'<option value=""><%- t("monthLabel")%></option><% var yearFld = (normalizedData[prefix + "cc_exp_year"] || normalizedData.expiration_period[prefix + "cc_exp_year"]);' +
	' var monthFld = (normalizedData[prefix + "cc_exp_month"] || normalizedData.expiration_period[prefix + "cc_exp_month"]); ' +
	' _.each( ["01","02","03","04","05","06","07","08","09","10","11","12"], function(monthVal){var selected=(monthFld.value==monthVal)?" selected":"";%>' +
	'<option value="<%= monthVal%>" <%- selected%>><%= monthVal%></option><%});%></select>' +
	'<select name="<%-prefix%>cc_exp_year" id="<%-prefix%>cc_exp_year" style="position: absolute; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;" tabindex="-1">' +
	'<option value=""><%- t("yearLabel")%></option><%var date=new Date();var startYear=date.getFullYear();var endYear=startYear+41;' +
	'for(var year=startYear; year < endYear; year++){var shortYear=(year).toString().substring(2);var selected=(yearFld.value==shortYear || yearFld.value==year)?" selected":"";%>' +
	'<option value="<%- shortYear%>" <%- selected%>><%- year%></option><%}%></select>' +
	'<div class="pmf-icon">&#xe600;</div><input autocomplete="off" type="tel" id="exp_date" maxlength="6" name="exp_date" placeholder="<%- t(\"mm_yy\")%>" title="<%- t(\"expiry_date\")%>" />' +
	'<div id="expiration_period_validation" class="validation_image"></div></div>',
	DEFAULT_SELECT_TPL   : '<div class="row <%-name%> default_select_wrap"><div class="pmf-icon <%-name%>"></div>' +
	'<% var lbl_txt = (opt.lbl_txt || t(name)); %><label class="<%-(opt.lbl_class||"")%>" for="<%-name%>"><%= lbl_txt%></label><select id="<%-name%>" name="<%-name%>" placeholder="<%= lbl_txt%>" title="<%= lbl_txt%>"  data-plugin="cSelect" <% if(opt.withSearch ){%> data-search="true" data-search-text="<%- t(\'cselect_search\') %>"<%}%> <%- (opt.disabled || "")%> >\n' +
	'<% var val = (opt.val || value), data = (opt.data || [{"value":val, "text":val}]); _.each(data, function(item){ var selected = item.value == val ? "selected" : "";%>' +
	'<option value="<%- item.value%>" <%- selected%> ><%- t(item.text)%></option>\n<%});%></select><div id="<%-name%>_validation" class="validation_image"></div></div>',
	RADIO_BTN_FIELD_TPL        : '<div class="row radio <%-name%>">' +
		'<label class="fld_label"><%- opt.lbl_txt %></label>' +
		'<div class="entries">' +
			'<% for (var i = 0; i < opt.data.length; i++) { %>' +
				'<div class="entry entry-<%- i %>" data-value="<%- opt.data[i].value %>">' +
					'<input value="<%- opt.data[i].value %>" id="<%- name + "-" + i %>" type="radio" name="<%- name %>" <% if (opt.val === opt.data[i].value) { %> checked <% } %>>' +
					'<label for="<%- name + "-" + i %>">' +
						'<span class="label-text"><%- t(opt.data[i].text) %></span>' +
					'</label>' +
				'</div>' +
			'<% } %>' +
			'<div id="<%-name%>_validation" class="validation_image"></div>' +
		'</div>' +
		'</div>',
	DISABLE_FIELD_VALIDATION_ICON_TPL: '<% if (fieldName) {%><span class="toggle_field_validation_icon" data-field-name="<%- fieldName %>"><a class="tooltip" tabindex="-1" onclick="app.util.toggleCompositePhoneValidation(\'<%- fieldName %>\')"></a><div class="field_help"><div class="tooltip_content"><%- t("phone_hint_validation_toggle")%></div></div></span><%} %>',
	/**
	 * Template for rendering a radio list with images - Mixin ".create-radio-images-widget" from common.less is used to style it
	 * @param opt.lbl_text - REQUIRED - widget label
	 * @param {Array<String>} opt.data - REQUIRED - dropDowns[ poFieldTemplate name ] data from getPaymentOptions.do.json
	 * @param opt.data[i].text - REQUIRED - radio option label text
	 * @param opt.data[i].value - REQUIRED - radio option value
	 * @param opt.logoPath - OPTIONAL - path for images (if missing "hidden" class is added) - contains image filename with a placeholder that will be replaced with opt.data.value for each option - e.g.: '../../../webapp/resources/img/konbini/logo_store_{0}.svg'
	 * @param opt.val - OPTIONAL - preselected value 
	 */
	RADIO_LIST_WITH_IMGS_TPL: '<div class="row radio <%- name %>" data-widget-name="radio-images">' +
		'<label class="fld_label"><%- opt.lbl_txt %></label>' +
		'<ul>' +
			'<% for (var i = 0; i < opt.data.length; i++) { %>' +
				'<% var logoPath = t(opt.logoPath, [opt.data[i].value]); %>' +
				'<li>' +
					'<input value="<%= opt.data[i].value %>" id="<%- name + "-" + opt.data[i].value %>" type="radio" name="<%- name %>" <% if (opt.val === opt.data[i].value) { %> checked <% } %>>' +
					'<label for="<%- name + "-" + opt.data[i].value %>">' +
						'<img src="<%= logoPath %>" alt="<%- t(opt.data[i].text) %>" class="<%- opt.logoPath ? "" : "hidden" %>"/>' +
						'<span class="label-text"><%- t(opt.data[i].text) %></span>' +
					'</label>' +
				'</li>' +
			'<% } %>' +
		'</ul>' +
		'<div id="<%-name%>_validation" class="validation_image"></div>' +
	'</div>',
	DIRECT_FLOW_CHECKBOX_TPL   : '<div class="row <%-name%> drf_checkbox_wrap"><input class="directFlowCheckbox" type="checkbox" id="<%-name%>" name="<%-name%>" value="true" <%-opt.checked%> ><label for="<%-name%>"><span class="text" data-no="<%-t("checkbox_no")%>" data-yes="<%-t("checkbox_yes")%>"></span><%= opt.lbl_txt%></label><% if(opt.validate){%><div id="<%-name%>_validation" class="validation_image"></div><%}%></div>',
	COMPOSITE_PHONE_NUMBER_TPL : '<div class="row <%-name%> composite_phone_wrap"><select name="country_phone_code" id="country_phone_code" data-plugin="cSelect">' +
		'<% value = (value || ""); var phone = value.split("-")[1]; var phoneCode = opt.phoneCode || value.split("-")[0]; (opt.phoneCodes || app.util.getFilteredPhoneCodes(app.phoneCodes, app.lastSelectedMethodType)).forEach(function(v) {%>' +
		'<option data-country="<%= v.iso%>" value="<%= v.phoneCode%>" <% if(phoneCode === v.phoneCode){%>selected<%}%> >+<%= v.phoneCode%></option><%})%></select><div class="<%-name%>_input composite_phone_input"><input type="hidden" data-type="composite_phone_hidden" id="<%-name%>" name="<%-name%>" value="<%-value%>"><input autocomplete="off" type="tel" id="composite_phone_suffix" class="<%-name%>_suffix composite_phone_suffix" placeholder="<%- t(name)%>" title="<%- t(name)%>" maxlength="<%-(opt.suffix_maxlength || 15)%>" value="<%- phone%>" ><div id="<%-name%>_validation" class="validation_image"></div></div></div>',
	TABLE_PM_HINT_TPL: '<div class="table_pm_hint">' +
	"<table>" +
	"	<tbody>" +
	"		<tr>" +
	"			<td><%- t('deposit_time') %></td>" +
	"			<td><%- t('instant') %></td>" +
	"		</tr>" +
	"		<tr>" +
	"			<td><%- t('minimum_deposit') %></td>" +
	"			<td><%- new Intl.NumberFormat(app.config.locale.replace('_', '-')," + 
	"					{ style: 'currency', currency: app.config.lastSelectedCurrency, minimumFractionDigits:0,maximumFractionDigits:2 })" +
	"						.format(app.validators.item_amount_1.checks.inRange.min) %>" +
	"			</td>" +
	"		</tr>" +
	"		<tr>" +
	"			<td><%- t('type') %></td>" +
	"			<td><%- t(pmType) %></td>" +
	"		</tr>" +
	"	</tbody>" +
	"</table>" +
	"<div class='method-hint <%- app.lastSelectedMethodType %>'>" +
	"	<%= t(pmHint) %>" +
	"</div>" +
	"</div>",
	REDIRECT_PAYMENT_METHODS_TYPES : {
		apmgw_Neteller : 'eWallet',
		apmgw_MoneyBookers : 'eWallet',
		apmgw_WebMoney: 'eWallet',
		apmgw_Webmoney_Direct_Integration_: 'eWallet',
		apmgw_Trustly: 'eWallet',
		apmgw_Citadel: 'eWallet',
		apmgw_ecoPayz: 'eWallet',
		apmgw_PaySafeCard: 'prepaidVoucher',
		apmgw_Neosurf: 'prepaidVoucher',
		apmgw_IDS: 'instantBankTransfer',
		apmgw_iDebit: 'instantBankTransfer',
		apmgw_Fast_Bank_Transfer: 'instantBankTransfer',
		apmgw_ABAQOOS: 'instantBankTransfer',
		apmgw_EPS: 'instantBankTransfer',
		apmgw_Euteller: 'instantBankTransfer',
		apmgw_Giropay: 'instantBankTransfer',
		apmgw_iDeal: 'instantBankTransfer',
		apmgw_Sofort: 'instantBankTransfer',
		apmgw_YANDEXMONEY: 'instantBankTransfer',
		apmgw_Safetypay: 'instantBankTransfer',
		apmgw_BOLETO: 'instantBankTransfer',
		apmgw_AstroPay: 'instantBankTransfer',
		apmgw_Todito_Cash: 'instantBankTransfer',
		apmgw_Interac: 'instantBankTransfer',
		apmgw_Trustly_DI: 'instantBankTransfer',
		apmgw_MuchBetter: 'instantBankTransfer',
		apmgw_Skrill_RapidTransfer: 'instantBankTransfer',
	},
	INAPPROPRIATE_CURRENCY_CLASS_NAME: 'unsuitable',
	PMS_WITH_NO_SAVE_UPO_CHECKBOX :{	/** skip SaveUpo checkbox */
		'cc_card'			: 1,
		'dc_card'   		: 1,
		'bancontact_cc_card': 1,
		'visa_checkout' 	: 1,
		"PPP_NOP_DisplayInstructions" : 1,
		"ppp_Cheque"                  : 1,
		"ppp_WesternUnion"            : 1,
		"ppp_bPay"                    : 1,
		"ppp_BankTransfer"            : 1,
		"ppp_BACSWithdraw"            : 1,
		"ppp_EasyEFTPayouts"          : 1,
		"apmgw_OfflineBanks"          : 1,
		"ppp_OfflineBanks"            : 1,
		"ppp_paddypower_shop"         : 1,
		"ppp_WireTransfer"            : 1,
		"ppp_InstantWireTransfer"     : 1,
		"apmgw_VIP_Preferred"     	  : 1, // fake upo - treatItLikePm
		// "apmgw_PlayPlus"     		  : 1, // fake upo - treatItLikePm
		"ppp_GooglePay"               : 1, // skip SaveUpo checkbox
		"apmgw_MobilePay"             : 1, // skip SaveUpo checkbox
		"ppp_ApplePay"                : 1
	},
	STATIC_PMS : { /** there is no need for an amount, nor for a deposit button */
		'ppp_WireTransfer': 1,
		'ppp_in_casino': 1,
		'ppp_PSKPayslip' : 1,
		'ppp_PSKDepositAtShop' : 1,
		'ppp_WTDep': 1,
		'ppp_MVP': 1,
		'apmgw_Lean': 1,
		'ppp_wt_salesforce': 1,
		'ppp_SSBTdeposit' : 1,
	},
	DIRECT_FLOW_FIELDS_2_PMS : {
		"paypalDirectFlow"          : "apmgw_expresscheckout",
		"skrillDirectFlow"          : "apmgw_MoneyBookers",
		"paysafeCardDirectFlow"		: "apmgw_PaySafeCard",
		"postFinanceCardDirectFlow" : "apmgw_PostFinance_Card",
		"postFinancePayDirectFlow"	: "apmgw_PostFinance_Pay",
		"satispayDirectFlow" 		: "apmgw_Satispay"
	},
	STATES :{
		"CA"  :[{"iso":"AB","name":"ALBERTA"},{"iso":"BC","name":"BRITISH COLUMBIA"},{"iso":"MB","name":"MANITOBA"},{"iso":"NB","name":"NEW BRUNSWICK"},{"iso":"NL","name":"NEWFOUNDLAND AND LABRADOR"},{"iso":"NT","name":"NORTHWEST TERRITORIES"},{"iso":"NS","name":"NOVA SCOTIA"},{"iso":"NU", "name":"NUNAVUT"},{"iso":"ON","name":"ONTARIO"},{"iso":"PE","name":"PRINCE EDWARD ISLAND"},{"iso":"QC","name":"QUEBEC"},{"iso":"SK","name":"SASKATCHEWAN"},{"iso":"YT","name":"YUKON TERRITORY"}],
	},
	// COUNTRIES : {
	// 	"en_US" : [{"iso":"","name":""},{"iso":"AF","name":"Afghanistan"},{"iso":"AX","name":"Aland Islands"},{"iso":"AL","name":"Albania"},{"iso":"DZ","name":"Algeria"},{"iso":"AS","name":"American Samoa"},{"iso":"AD","name":"Andorra"},{"iso":"AO","name":"Angola"},{"iso":"AI","name":"Anguilla"},{"iso":"AQ","name":"Antarctica"},{"iso":"AG","name":"Antigua and Barbuda"},{"iso":"AR","name":"Argentina"},{"iso":"AM","name":"Armenia"},{"iso":"AW","name":"Aruba"},{"iso":"AU","name":"Australia"},{"iso":"AT","name":"Austria"},{"iso":"AZ","name":"Azerbaijan"},{"iso":"BS","name":"Bahamas"},{"iso":"BH","name":"Bahrain"},{"iso":"BD","name":"Bangladesh"},{"iso":"BB","name":"Barbados"},{"iso":"BY","name":"Belarus"},{"iso":"BE","name":"Belgium"},{"iso":"BZ","name":"Belize"},{"iso":"BJ","name":"Benin"},{"iso":"BM","name":"Bermuda"},{"iso":"BT","name":"Bhutan"},{"iso":"BO","name":"Bolivia"},{"iso":"BA","name":"Bosnia and Herzegovina"},{"iso":"BW","name":"Botswana"},{"iso":"BV","name":"Bouvet Island "},{"iso":"BR","name":"Brazil"},{"iso":"IO","name":"British Indian Ocean Territory"},{"iso":"BN","name":"Brunei Darussalam"},{"iso":"BG","name":"Bulgaria"},{"iso":"BF","name":"Burkina Faso"},{"iso":"BI","name":"Burundi"},{"iso":"CV","name":"Cabo Verde"},{"iso":"KH","name":"Cambodia"},{"iso":"CM","name":"Cameroon"},{"iso":"CA","name":"Canada"},{"iso":"BQ","name":"Caribbean Netherlands"},{"iso":"KY","name":"Cayman Islands"},{"iso":"CF","name":"Central African Republic"},{"iso":"TD","name":"Chad"},{"iso":"CL","name":"Chile"},{"iso":"CN","name":"China"},{"iso":"CX","name":"Christmas Island"},{"iso":"CC","name":"Cocos (Keeling) Islands"},{"iso":"CO","name":"Colombia"},{"iso":"KM","name":"Comoros"},{"iso":"CG","name":"Congo"},{"iso":"CD","name":"Congo, Democratic Republic of the"},{"iso":"CK","name":"Cook Islands"},{"iso":"CR","name":"Costa Rica"},{"iso":"HR","name":"Croatia"},{"iso":"CU","name":"Cuba"},{"iso":"CW","name":"Curacao"},{"iso":"CY","name":"Cyprus"},{"iso":"CZ","name":"Czech Republic"},{"iso":"CI","name":"Côte dIvoire"},{"iso":"DK","name":"Denmark"},{"iso":"DJ","name":"Djibouti"},{"iso":"DM","name":"Dominica"},{"iso":"DO","name":"Dominican Republic"},{"iso":"EC","name":"Ecuador"},{"iso":"EG","name":"Egypt"},{"iso":"SV","name":"El Salvador"},{"iso":"GQ","name":"Equatorial Guinea"},{"iso":"ER","name":"Eritrea"},{"iso":"EE","name":"Estonia"},{"iso":"ET","name":"Ethiopia"},{"iso":"FK","name":"Falkland Islands"},{"iso":"FO","name":"Faroe Islands"},{"iso":"FJ","name":"Fiji"},{"iso":"FI","name":"Finland"},{"iso":"FR","name":"France"},{"iso":"GF","name":"French Guiana"},{"iso":"PF","name":"French Polynesia"},{"iso":"TF","name":"French Southern Territories"},{"iso":"GA","name":"Gabon"},{"iso":"GM","name":"Gambia"},{"iso":"GE","name":"Georgia"},{"iso":"DE","name":"Germany"},{"iso":"GH","name":"Ghana"},{"iso":"GI","name":"Gibraltar"},{"iso":"GR","name":"Greece"},{"iso":"GL","name":"Greenland"},{"iso":"GD","name":"Grenada"},{"iso":"GP","name":"Guadeloupe"},{"iso":"GU","name":"Guam"},{"iso":"GT","name":"Guatemala"},{"iso":"GG","name":"Guernsey"},{"iso":"GN","name":"Guinea"},{"iso":"GW","name":"Guinea-Bissau"},{"iso":"GY","name":"Guyana"},{"iso":"HT","name":"Haiti"},{"iso":"HM","name":"Heard Island and McDonald Islands"},{"iso":"VA","name":"Holy See (Vatican)"},{"iso":"HN","name":"Honduras"},{"iso":"HK","name":"Hong Kong"},{"iso":"HU","name":"Hungary"},{"iso":"IS","name":"Iceland"},{"iso":"IN","name":"India"},{"iso":"ID","name":"Indonesia"},{"iso":"IR","name":"Iran, Islamic Republic of"},{"iso":"IQ","name":"Iraq"},{"iso":"IE","name":"Ireland"},{"iso":"IM","name":"Isle of Man"},{"iso":"IL","name":"Israel"},{"iso":"IT","name":"Italy"},{"iso":"JM","name":"Jamaica"},{"iso":"JP","name":"Japan"},{"iso":"JE","name":"Jersey"},{"iso":"JO","name":"Jordan"},{"iso":"KZ","name":"Kazakhstan"},{"iso":"KE","name":"Kenya"},{"iso":"KI","name":"Kiribati"},{"iso":"KP","name":"Korea, Democratic Peoples Republic of"},{"iso":"KR","name":"Korea, Republic of"},{"iso":"XK","name":"Kosovo"},{"iso":"KW","name":"Kuwait"},{"iso":"KG","name":"Kyrgyzstan"},{"iso":"LA","name":"Lao Peoples Democratic Republic"},{"iso":"LV","name":"Latvia"},{"iso":"LB","name":"Lebanon"},{"iso":"LS","name":"Lesotho"},{"iso":"LR","name":"Liberia"},{"iso":"LY","name":"Libya"},{"iso":"LI","name":"Liechtenstein"},{"iso":"LT","name":"Lithuania"},{"iso":"LU","name":"Luxembourg"},{"iso":"MO","name":"Macao"},{"iso":"MK","name":"Macedonia"},{"iso":"MG","name":"Madagascar"},{"iso":"MW","name":"Malawi"},{"iso":"MY","name":"Malaysia"},{"iso":"MV","name":"Maldives"},{"iso":"ML","name":"Mali"},{"iso":"MT","name":"Malta"},{"iso":"MH","name":"Marshall Islands"},{"iso":"MQ","name":"Martinique"},{"iso":"MR","name":"Mauritania"},{"iso":"MU","name":"Mauritius"},{"iso":"YT","name":"Mayotte"},{"iso":"MX","name":"Mexico"},{"iso":"FM","name":"Micronesia, Federated States of"},{"iso":"MD","name":"Moldova, Republic of"},{"iso":"MC","name":"Monaco"},{"iso":"MN","name":"Mongolia"},{"iso":"ME","name":"Montenegro"},{"iso":"MS","name":"Montserrat"},{"iso":"MA","name":"Morocco"},{"iso":"MZ","name":"Mozambique"},{"iso":"MM","name":"Myanmar"},{"iso":"NA","name":"Namibia"},{"iso":"NR","name":"Nauru"},{"iso":"NP","name":"Nepal"},{"iso":"NL","name":"Netherlands"},{"iso":"AN","name":"Netherlands antilles"},{"iso":"NC","name":"New Caledonia"},{"iso":"NZ","name":"New Zealand"},{"iso":"NI","name":"Nicaragua"},{"iso":"NE","name":"Niger"},{"iso":"NG","name":"Nigeria"},{"iso":"NU","name":"Niue"},{"iso":"NF","name":"Norfolk Island"},{"iso":"MP","name":"Northern Mariana Islands"},{"iso":"NO","name":"Norway"},{"iso":"OM","name":"Oman"},{"iso":"PP","name":"PP name"},{"iso":"PK","name":"Pakistan"},{"iso":"PW","name":"Palau"},{"iso":"PS","name":"Palestine"},{"iso":"PA","name":"Panama"},{"iso":"PG","name":"Papua New Guinea"},{"iso":"PY","name":"Paraguay"},{"iso":"PE","name":"Peru"},{"iso":"PH","name":"Philippines"},{"iso":"PN","name":"Pitcairn"},{"iso":"PL","name":"Poland"},{"iso":"PT","name":"Portugal"},{"iso":"PR","name":"Puerto Rico"},{"iso":"QA","name":"Qatar"},{"iso":"RE","name":"Reunion"},{"iso":"RO","name":"Romania"},{"iso":"RU","name":"Russian Federation"},{"iso":"RW","name":"Rwanda"},{"iso":"BL","name":"Saint Barthelemy"},{"iso":"SH","name":"Saint Helena"},{"iso":"KN","name":"Saint Kitts and Nevis"},{"iso":"LC","name":"Saint Lucia"},{"iso":"MF","name":"Saint Martin (French Part)"},{"iso":"PM","name":"Saint Pierre and Miquelon"},{"iso":"VC","name":"Saint Vincent and the Grenadines"},{"iso":"WS","name":"Samoa"},{"iso":"SM","name":"San Marino"},{"iso":"SA","name":"Saudi Arabia"},{"iso":"SN","name":"Senegal"},{"iso":"RS","name":"Serbia"},{"iso":"SC","name":"Seychelles"},{"iso":"SL","name":"Sierra Leone"},{"iso":"SG","name":"Singapore"},{"iso":"SX","name":"Sint Maarten (Dutch part)"},{"iso":"SK","name":"Slovakia"},{"iso":"SI","name":"Slovenia"},{"iso":"SB","name":"Solomon Islands"},{"iso":"SO","name":"Somalia"},{"iso":"ZA","name":"South Africa"},{"iso":"GS","name":"South Georgia and the South Sandwich Islands"},{"iso":"SS","name":"South Sudan"},{"iso":"ES","name":"Spain"},{"iso":"LK","name":"Sri Lanka"},{"iso":"SD","name":"Sudan"},{"iso":"SR","name":"Suriname"},{"iso":"SJ","name":"Svalbard and Jan Mayen"},{"iso":"SZ","name":"Swaziland"},{"iso":"SE","name":"Sweden"},{"iso":"CH","name":"Switzerland"},{"iso":"SY","name":"Syrian Arab Republic"},{"iso":"ST","name":"São Tomé and Príncipe"},{"iso":"TW","name":"Taiwan"},{"iso":"TJ","name":"Tajikistan"},{"iso":"TZ","name":"Tanzania, United Republic of"},{"iso":"TH","name":"Thailand"},{"iso":"TL","name":"Timor-Leste"},{"iso":"TG","name":"Togo"},{"iso":"TK","name":"Tokelau"},{"iso":"TO","name":"Tonga"},{"iso":"TT","name":"Trinidad and Tobago"},{"iso":"TN","name":"Tunisia"},{"iso":"TR","name":"Turkey"},{"iso":"TM","name":"Turkmenistan"},{"iso":"TC","name":"Turks and Caicos Islands"},{"iso":"TV","name":"Tuvalu"},{"iso":"UG","name":"Uganda"},{"iso":"UA","name":"Ukraine"},{"iso":"AE","name":"United Arab Emirates"},{"iso":"GB","name":"United Kingdom"},{"iso":"US","name":"United States"},{"iso":"UM","name":"United States Minor Outlying Islands"},{"iso":"UY","name":"Uruguay"},{"iso":"UZ","name":"Uzbekistan"},{"iso":"VU","name":"Vanuatu"},{"iso":"VE","name":"Venezuela"},{"iso":"VN","name":"Vietnam"},{"iso":"VG","name":"Virgin Islands, British"},{"iso":"VI","name":"Virgin Islands, U.S."},{"iso":"WF","name":"Wallis and Futuna"},{"iso":"EH","name":"Western Sahara"},{"iso":"YE","name":"Yemen"},{"iso":"ZM","name":"Zambia"},{"iso":"ZW","name":"Zimbabwe"}]
	// },
	EXTRA_FIELDS_FOR_VALIDATION : { /** available for validation, even if they are missing in the srvPmFields array */
		'expiration_period'         : 1,
		'item_amount_1'             : 1,
		'blocked_method'            : 1,
		'sightline_ssn'             : 1
	},
	VALIDATE_FIELD_ALTERNATIVE_MESSAGE_KEYS: [
		'minMsgKey', 'maxMsgKey',
		'restricted_cardTypeMsgKey', 'restricted_cardProductMsgKey', 'restricted_issuerCountryMsgKey', 'restricted_userCountryMsgKey',
		'restrictedCCMsgKey', 'restrictedCCCurrencyMsgKey', 'allowedCCMsgKey', 'restrictedCCCountryMsg', 'invalidEmailMsgKey', 'notEnrolledMsgKey', 'restricted_bothBrandsMsgKey'
	],
	PM_EXTRA_DATA_URL: {
		apmgw_VIP_Preferred: {url: "/ppp/getAccountDetails.do"},
		apmgw_PlayPlus: {url: "/ppp/getAccountDetails.do", params: {checkBalance: "false"}}
	},
	ASYNC_CHECK_CARD_TYPE: {
		"CREDIT_CARD" : 'Credit',
		"DEBIT_CARD"  : 'Debit',
	},
	UPPER_CASE_FIELD_VALUE: {
		'giropay_bic':1
	},
	PMS_WITH_DUMMY_CARD_UPO: {
		"ppp_ApplePay" : 1
	},
	PREDEPOSIT_CHECK_URL : "/ppp/preDepositCheck.do"
};